<template>
    <annotation-popup
        v-if="enabled"
        :range="selectedRange"
        :section="selectedSection"
        :current_annotation="current_annotation"
        :position="isTouch ? 'bottom' : 'top'"
        :enable_private_annotations="enable_private_annotations"
        @create="createAnnotation"
        @updateComments="$emit('updateComments', $event)"
    />
</template>

<script>
import AnnotationPopup from './annotation-popup.vue';

export default {
    components: {
        AnnotationPopup,
    },

    props: {
        scope: { type: String, default: null },
        enabled: true,
        current_annotation: {},
        enable_private_annotations: { type: Boolean, default: false },
    },

    data() {
        return {
            renderers: [],
            selectedRange: null,
            selectedSection: null,
            isTouch: false,
        }
    },

    methods: {
        createAnnotation({ type, created }) {
            let position = this.getPositionInDocument(this.selectedRange);

            this.$emit('create', {
                type: type,
                range: this.selectedRange,
                section: this.selectedSection,
                positionTop: position.top,
                positionLeft: position.left,
                created: (id) => created(id),
            });
        },
        getPositionInDocument(el) {
            var rect = el.getBoundingClientRect(),
            scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
        },
        clearSelection() {
            this.selectedRange = null;
            this.selectedSection = null;
        },
        preserveSelection() {
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(this.selectedRange);
        },
        isValidSelection(selection) {
            return ! selection.isCollapsed
                && selection.toString().length > 0
                && selection.rangeCount > 0;
        },
        isNewRange(range) {
            return range != this.selectedRange;
        },
        isTouchCapable() {
            return 'ontouchstart' in window
                || (window.DocumentTouch && document instanceof window.DocumentTouch)
                || navigator.maxTouchPoints > 0
                || window.navigator.msMaxTouchPoints > 0;
        },
        highlightEvent(e) {
            if (e.keyCode && ! ([37, 38, 39, 40].includes(e.keyCode))) {
                // detected a keypress, but not an arrow
                return;
            }

            if (! this.enabled) {
                return;
            }

            if (e.target.classList.contains('popup-button')) {
                this.preserveSelection();
                return;
            }

            const selection = window.getSelection && window.getSelection();

            if (selection && selection.rangeCount > 0) {
                const range = selection.getRangeAt(0);
                const sectionParent = selection.anchorNode.parentElement.closest('[data-annotation-section]');

                if (this.isValidSelection(selection) && this.isNewRange(range) && sectionParent) {
                    this.selectedRange = range;
                    this.selectedSection = sectionParent;
                } else {
                    this.clearSelection();
                }
            }
        },
    },

    mounted() {
        this.isTouch = this.isTouchCapable();
        const highlight_event = this.isTouch ? 'touchend' : 'mouseup';

        const elements = this.scope
            ? document.querySelectorAll(this.scope)
            : [document.documentElement];

        elements.forEach(function (element) {
            if (this.isTouch) {
                element.addEventListener('mouseup', (e) => {
                    this.clearSelection();
                });
            }

            element.addEventListener(highlight_event, this.highlightEvent);
        }, this);

        window.addEventListener('keyup', this.highlightEvent);
    },
}
</script>
